export default "{\n    \"replaceInvoice\": \"Reemplazar Factura\"\n}\n"